module.exports = __webpack_public_path__ + "img/category-annual-tickets_old.811ee1bb.jpg";